import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
    Button,
    Text,
    Spacer,
    Flex,
    List,
} from '@zillow/constellation';

import ModalActions from 'app/shared/actions/ModalActions';
import analyticsUtils from 'app/client/utils/analyticsUtils';
import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';
import stringHelper from 'app/shared/utils/stringHelper';
import { DELIMITER } from 'app/shared/constants/AnalyticsDelimiterConstants';
import NotificationModule from 'app/client/workers/notificationModule';
import {
    StyledMDActionsContainer,
    StyledMDContainer,
    StyledMDContent,
    StyledMDContentContainer,
} from 'app/shared/containers/ModalContainer/StyledComponents';

const { startCaseRemoveSpace } = stringHelper;

const NotificationPromptModal = () => {
    const dispatch = useDispatch();

    const labelPrefix = `${startCaseRemoveSpace('Pre-Prompt')}${DELIMITER}`;
    const label = analyticsUtils.getPageContextLabel(labelPrefix);
    const dispatchGA = eventParams => dispatch(analyticsUtils.track.GAEventV2(eventParams, { label }));

    useEffect(() => dispatchGA(AnalyticsConstants.GA_EVENTS.NOTIFICATION_PRE_PROMPT_DISPLAYED));

    const handleYesClick = () => {
        dispatchGA(AnalyticsConstants.GA_EVENTS.NOTIFICATION_PRE_PROMPT_GRANTED);
        NotificationModule.requestPermission();
        dispatch(ModalActions.hideModal());
    };

    const handleNoClick = () => {
        dispatchGA(AnalyticsConstants.GA_EVENTS.NOTIFICATION_PRE_PROMPT_DENIED);
        NotificationModule.setNotificationPromptCookieAsDeclined();
        dispatch(ModalActions.hideModal());
    };

    return (
        <StyledMDContainer>
            <StyledMDContentContainer>
                <StyledMDContent>
                    <Spacer marginBottom="xs">
                        <Text fontType="bodyHeading">Notify me when:</Text>
                    </Spacer>
                    <List>
                        <List.Item>My listing is updated on Zillow, Trulia, and HotPads</List.Item>
                        <List.Item>My listing is expiring soon</List.Item>
                    </List>
                </StyledMDContent>
            </StyledMDContentContainer>
            <StyledMDActionsContainer>
                <Flex display="flex" justifyContent="flex-end">
                    <Spacer marginRight="xs">
                        <Button onClick={handleNoClick}>Not now</Button>
                    </Spacer>
                    <Button buttonType="primary" onClick={handleYesClick}>Yes</Button>
                </Flex>
            </StyledMDActionsContainer>
        </StyledMDContainer>
    );
};

export { NotificationPromptModal };
export default NotificationPromptModal;
